import React, { useState, useRef, useEffect } from 'react';
import Footer from '../../../../components/Footer/Footer';
import { GoogleGenerativeAI } from '@google/generative-ai';

const API_KEY = "AIzaSyB1meBkLvfW2b-zEs52tVvCvd622uqaQAc"; // ⚠️ frontend only for testing

const genAI = new GoogleGenerativeAI(API_KEY);
const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash", apiVersion: 'v1' });
// gemini-1.5-flash
// gemini-1.0-pro

function SipAiTest({ language }) {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const chatEndRef = useRef(null);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const sendMessage = async () => {
        if (!input.trim() || loading) return;

        const userMessage = { text: input, sender: 'user' };
        setMessages(prev => [...prev, userMessage]);
        setInput('');
        setLoading(true);

        try {
            const result = await model.generateContent(input);
            const response = result.response.text();

            setMessages(prev => [
                ...prev,
                { text: response, sender: 'bot' }
            ]);
        } catch (error) {
            setMessages(prev => [
                ...prev,
                { text: "Unable to connect to Gemini. Please try again.", sender: 'bot' }
            ]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                background: '#f7f9fc',
                fontFamily: 'system-ui, sans-serif'
            }}>
                {/* Header */}
                <div style={{
                    padding: '16px 24px',
                    background: '#4285f4',
                    color: '#fff',
                    fontSize: 18,
                    fontWeight: 600
                }}>
                    DODEAL Assistant
                </div>

                {/* Chat Area */}
                <div style={{
                    flex: 1,
                    padding: 20,
                    overflowY: 'auto'
                }}>
                    {messages.length === 0 && (
                        <div style={{
                            textAlign: 'center',
                            color: '#777',
                            marginTop: 100
                        }}>
                            Ask anything to get started ✨
                        </div>
                    )}

                    {messages.map((msg, i) => (
                        <div
                            key={i}
                            style={{
                                display: 'flex',
                                justifyContent: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                                marginBottom: 12
                            }}
                        >
                            <div style={{
                                background: msg.sender === 'user' ? '#4285f4' : '#ffffff',
                                color: msg.sender === 'user' ? '#fff' : '#000',
                                padding: '12px 16px',
                                borderRadius: 16,
                                maxWidth: '70%',
                                lineHeight: 1.5,
                                boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
                            }}>
                                {msg.text}
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div style={{ color: '#888', fontSize: 14 }}>
                            Gemini is thinking…
                        </div>
                    )}

                    <div ref={chatEndRef} />
                </div>

                {/* Input */}
                <div style={{
                    padding: 16,
                    borderTop: '1px solid #ddd',
                    display: 'flex',
                    background: '#fff'
                }}>
                    <input
                        type="text"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && sendMessage()}
                        placeholder="Type your message..."
                        style={{
                            flex: 1,
                            padding: 12,
                            borderRadius: 8,
                            border: '1px solid #ccc',
                            fontSize: 15,
                            color: "#333"
                        }}
                    />
                    <button
                        onClick={sendMessage}
                        disabled={loading}
                        style={{
                            marginLeft: 10,
                            padding: '0 20px',
                            background: '#4285f4',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            fontSize: 15,
                            cursor: 'pointer',
                            width: "120px"
                        }}
                    >
                        Send
                    </button>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default SipAiTest;
